const blocVideo = document.querySelectorAll('.admin-area .bloc__wrapper--video');
const closePopupArea = document.querySelectorAll('.admin-area .popup-area .close-area-popup');

for (let i = 0; i < blocVideo.length; i++) {
    blocVideo[i].addEventListener('click', function(){
        blocVideo[i].closest('.bloc').querySelector('.popup-area').classList.add('show-popup');
    })
}

for (let i = 0; i < closePopupArea.length; i++) {
    closePopupArea[i].addEventListener('click', function(){
        closePopupArea[i].closest('.bloc').querySelector('.popup-area').classList.remove('show-popup');
    })
}